"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CARDANO_TESTNET_API_ENDPOINT = exports.CARDANO_API_ENDPOINT = exports.MEMO_LABEL = exports.CARDANO_COIN_TYPE = exports.CARDANO_PURPOSE = exports.TTL_GAP = exports.STAKING_ADDRESS_INDEX = void 0;
const live_env_1 = require("@ledgerhq/live-env");
exports.STAKING_ADDRESS_INDEX = 0;
exports.TTL_GAP = 7200;
exports.CARDANO_PURPOSE = 1852;
exports.CARDANO_COIN_TYPE = 1815;
exports.MEMO_LABEL = 674;
exports.CARDANO_API_ENDPOINT = (0, live_env_1.getEnv)("CARDANO_API_ENDPOINT");
exports.CARDANO_TESTNET_API_ENDPOINT = (0, live_env_1.getEnv)("CARDANO_TESTNET_API_ENDPOINT");
//# sourceMappingURL=constants.js.map